import { useState } from 'react';
import { useDispatch } from 'react-redux';
import Swal from 'sweetalert2';
import endpoints from '../../config/endpoints';
import { popupSlice } from '../../services/reducers';
import { setLoading } from '../../services/reducers/homeSlice';
import restApi from '../../services/restApi';
import { useAppSelector } from '../../services/store';

const Bijack = ({ orderId }) =>{
  const dispatch: any  = useDispatch();
  const [file, setFile] = useState<any>();

  const send = async () => {
    dispatch(setLoading(true));
    const formData = new FormData()
    formData.append('file', file.data)
    const res = await restApi(endpoints.order.bijack + orderId , true).upload(formData);

    if(res.code == 200){
      Swal.fire({
        title: 'موفق',
        text: 'فایل با موفقیت آپلود شد.',
        icon: 'success',
        confirmButtonText: 'متوجه شدم'
      })
    } else {
      Swal.fire({
        title: 'ناموفق',
        text: res?.data,
        icon: 'error',
        confirmButtonText: 'متوجه شدم'
      })
    }
    dispatch(popupSlice.hide())
    dispatch(setLoading(false));
  };

  return(
    <main className="derhamMain">
      <span className="derhamHeader">
        <i className="coinSvg"></i>
        <p className="blueText">آپلود عکس بیجک</p>
      </span>
      <input type="file" className="derhamInput" onChange={(e: any) => {
        setFile({
          preview: URL.createObjectURL(e.target.files[0]),
          data: e.target.files[0],
        })
      }}
      />
      <span className="derhamButtons">
         <button className="cancelDerham" onClick={() => dispatch(popupSlice.hide())}>انصراف</button>
        <button className="dashboardHeader clickable" onClick={send}>ثبت</button>
      </span>
    </main>
  )
}
export default Bijack